
import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from "../BrandLogo";

export const Logo: React.FC = () => {
  // Check if we're on client-login for priority loading
  const isClientLogin = window.location.pathname === '/client-login';
  
  return (
    <Link to="/" className="flex items-center" aria-label="Dialgia Group Home">
      {/* Progressive responsive logo sizing: mobile 60px, tablet 65px, desktop 70px */}
      <BrandLogo 
        variant="horizontal" 
        size={58} 
        className="h-[48px] md:h-[58px] lg:h-[66px] w-auto" 
        priority={isClientLogin}
      />
    </Link>
  );
};
